import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ViewDetails from "assets/ViewDetailsNew.svg";

const ViewButton = ({ state, url }) => {
  const navigate = useNavigate();

  const handleEditClick = () => {
    navigate(url, { state });
  };

  return <img src={ViewDetails} onClick={handleEditClick} alt="View Details" />;
};

export default ViewButton;
